'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const lodash_1 = require("lodash");
const $ = require("jquery");
class Header {
    constructor() {
        $(window).on('scroll', (0, lodash_1.throttle)((e) => {
            const scroll = $(e.currentTarget).scrollTop();
            if (scroll > 130) {
                $('.bulletHeader').attr('data-is-scroll', 'true');
            }
            else {
                $('.bulletHeader').attr('data-is-scroll', 'false');
            }
        }, 500));
    }
}
exports.Header = Header;
exports.default = Header;
